<template lang="pug">
  div.items-area
    div.slit(v-for="(n , i) in slits",v-if="i !== slits.length - 1",:style="sty(i)")
      div.items(:style="styItems()")
        Item(v-for="(nc , ss) in slits[i].item",:dat="nc",:pnum="i",:num="ss",:key="ss")
      div.flr(:style="styFloor()")
        FItem(v-for="(nc , ss) in slits[i].floor",:dat="nc",:pnum="i",:num="ss",:key="ss")
</template>

<script>
import Item from './Item.vue';
import FItem from './FItem.vue';
export default {
  name: 'Items',
  components: {
    Item,
    FItem
  },
  data () {
    return {
      parent: 0,
      child: 0,
      height: 0,
      $tar: {},
      dragged: {},
      slits: []
    };
  },
  computed: {
  },
  watch: {
    number () {
      this.slits = this.sets[this.number].slits;
    },
    sets () {
      this.slits = this.sets[this.number].slits;
    }
  },
  methods: {
    sty (i) {
      this.height = this.c2p(this.sets[this.number].size[1] + this.sets[this.number].size[3]);
      return {
        height: this.height + 'px',
        zIndex: 1000 - i
      };
    },
    styItems () {
      let height = this.c2p(this.sets[this.number].size[1]);
      return {
        height: height + 'px'
      };
    },
    styFloor () {
      let height = this.c2p(this.sets[this.number].size[3]);
      return {
        height: height + 'px'
      };
    }
  },
  created () {
    this.slits = this.sets[this.number].slits;
  },
  mounted () {
  }
};
</script>

<style lang="stylus" scoped>
  .items-area
    left 0
    top 0
    position absolute
    z-index 1
    .slit
      position absolute
      left 0
      top 0
      /*border 1px solid #ff0000*/
      &.over
        .item,
        .prev
          display block
          pointer-events none
</style>



// WEBPACK FOOTER //
// src/components/side/Items.vue